/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TuteurHistoryGridDto
 */
export interface TuteurHistoryGridDto {
    /**
     * 
     * @type {number}
     * @memberof TuteurHistoryGridDto
     */
    idtuteurHistory?: number;
    /**
     * 
     * @type {number}
     * @memberof TuteurHistoryGridDto
     */
    iduser?: number;
    /**
     * 
     * @type {number}
     * @memberof TuteurHistoryGridDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {number}
     * @memberof TuteurHistoryGridDto
     */
    idtuteur?: number;
    /**
     * 
     * @type {string}
     * @memberof TuteurHistoryGridDto
     */
    action?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurHistoryGridDto
     */
    actionType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurHistoryGridDto
     */
    actionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TuteurHistoryGridDto
     */
    userName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TuteurHistoryGridDto
     */
    ifapmeSide?: Array<string> | null;
}

/**
 * Check if a given object implements the TuteurHistoryGridDto interface.
 */
export function instanceOfTuteurHistoryGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurHistoryGridDtoFromJSON(json: any): TuteurHistoryGridDto {
    return TuteurHistoryGridDtoFromJSONTyped(json, false);
}

export function TuteurHistoryGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurHistoryGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtuteurHistory': !exists(json, 'idtuteurHistory') ? undefined : json['idtuteurHistory'],
        'iduser': !exists(json, 'iduser') ? undefined : json['iduser'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'actionType': !exists(json, 'actionType') ? undefined : json['actionType'],
        'actionDate': !exists(json, 'actionDate') ? undefined : (new Date(json['actionDate'])),
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'ifapmeSide': !exists(json, 'ifapmeSide') ? undefined : json['ifapmeSide'],
    };
}

export function TuteurHistoryGridDtoToJSON(value?: TuteurHistoryGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtuteurHistory': value.idtuteurHistory,
        'iduser': value.iduser,
        'idpersonne': value.idpersonne,
        'idtuteur': value.idtuteur,
        'action': value.action,
        'actionType': value.actionType,
        'actionDate': value.actionDate === undefined ? undefined : (value.actionDate.toISOString()),
        'userName': value.userName,
        'ifapmeSide': value.ifapmeSide,
    };
}

